export default {
    AdditionalPageTypes: true,
    Admin: true,
    Advertising: true,
    Advertising2: {
        adServers: ["simple"],
        adSizes: ["mpu", "banner", "banner-large"]
    },
    AggregatedContentFeed: true,
    AllowCustomFields: false,
    AppConfig: true,
    AppEcommerceManager: true,
    AppScorePredictor: false,
    AppSocialManager: true,
    AppTicketingManager: true,
    BreakingNews: false,
    BuildManager: true,
    Calendar: true,
    CustomCommentary: true,
    CustomLineups: true,
    CustomTables: false,
    CustomTags: false,
    Dashboard: true,
    Fixtures: true,
    Forms: true,
    HomepageManager: true,
    HomepageNewsPromo: true,
    HomepagePlayerHighlight: true,
    Lab: false,
    MatchdayTakeover: true,
    Media: true,
    News: true,
    OptaIntegration: true,
    Organisations: false,
    OverlayPromos: true,
    Pages: true,
    PagesAltTitles: true,
    PlatformOptions: true,
    PlayerVoting: true,
    PreventEntitlementEmails: false,
    Profile: true,
    RelatedContentTagging: true,
    RewardsManager: false,
    RewardPoints: false,
    Rover: false,
    Settings: false,
    SiteConfig: true,
    Sponsors: true,
    Squads: true,
    SsoUsers: false,
    StreamAMGIntegration: false,
    Streamline: true,
    StreamlineFiltersv2: true,
    StreamlineSubtitles: true,
    StreamlineAutoSubtitles: true,
    TeamCrestManager: true,
    Videos: true,
    Voice: false,
    WebStats: true,
};
